import { SitesProvider } from '@/context/sitesContext';
import { AuthProvider } from '@/context/authContext';
import { ProceduresProvider } from '@/context/proceduresContext';
import { CornerstoneProvider } from '@/context/cornerstoneContext';
import { PatientsProvider } from '@/context/patientsContext';

export function ContextProvider({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <SitesProvider>
        <ProceduresProvider>
          <PatientsProvider>
            <CornerstoneProvider>
              { children }
            </CornerstoneProvider>
          </PatientsProvider>
        </ProceduresProvider>
      </SitesProvider>
    </AuthProvider>
  );
}
